import React, { useState } from 'react';
import { Loader } from 'lucide-react';

const OnboardingComplete = ({ onFinish, validatedEmail }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleFinish = async () => {
    setIsLoading(true);
    await onFinish();
    setIsLoading(false);
  };

  return (
    <div className="text-center py-8">
      <div className="text-7xl mb-6 animate-bounce">
        🎉
      </div>
      <h2 className="text-3xl sm:text-4xl font-bold mb-4 bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
        ¡Onboarding Completado!
      </h2>
      <p className="text-gray-300 mb-8 text-lg">
        Has aceptado todas las reglas de la comunidad NSL. Ahora procederemos al último paso para activar tu cuenta.
      </p>

      <button
        onClick={handleFinish}
        disabled={isLoading}
        className={`inline-flex items-center gap-2 font-bold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg ${
          isLoading
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black transform hover:scale-105 hover:shadow-yellow-500/50'
        }`}
      >
        {isLoading && <Loader className="w-5 h-5 animate-spin" />}
        {isLoading ? 'Procesando...' : 'Finalizar Incorporación'}
      </button>
    </div>
  );
};

export default OnboardingComplete;